(function() {
	'use strict';
	angular.module('app.leanProjects')
		.controller('individualPerformanceChartCtrl', individualPerformanceChartCtrl);
	
	individualPerformanceChartCtrl.$inject = ['$scope','rawChartData'];
	
	function individualPerformanceChartCtrl($scope, rawChartData) {
		var chartData= massageRawData(rawChartData);
		$scope.empty = !chartData || chartData.length === 0;
		$scope.categories = [];
		$scope.chartHeight = window.innerHeight - 66;
		for (var i=0; i < chartData.length; i++) {
			$scope.categories.push(chartData[i].User);
		}
		$scope.chartData = chartData;
		
		// Exclude users without any tasks, and rename the fields in the array elements to fit the format expected by the directive
		function massageRawData(rawData) {
			var data = [];
			for (var i = 0; i < rawData.length; i++) {
				if (rawData[i].totalTasksAssigned > 0) {
					var entry = {
						'User': rawData[i].responsible,
						'Completed': rawData[i].tasksCompleted,
						'Pending': rawData[i].tasksPending,
						'Started': rawData[i].tasksStarted,
						'Total': rawData[i].totalTasksAssigned
					};
					data.push(entry);
				}
			}
			var x = data.sort(function(a, b) {
				return b.Total - a.Total;
			});
			return data;
		}
	}
})();